import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaInstagram, FaArrowUp } from 'react-icons/fa';

const FooterWrapper = styled.footer`
  background-color: var(--bg-primary);
  border-top: 1px solid var(--border-subtle);
  padding: 3rem 1.5rem 2rem;
  width: 100%;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
  }
`;

const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  h4 {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;

    span {
      background: var(--gradient-accent);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  p {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const SocialIcon = styled.a`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  transition: all 0.25s ease;
  text-decoration: none;

  &:hover {
    background: var(--bg-tertiary);
    color: var(--accent-cyan);
    border-color: var(--accent-cyan);
    transform: translateY(-3px);
  }
`;

const BackToTopButton = styled.button`
  background: var(--bg-secondary);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  padding: 0.6rem 1.1rem;
  border-radius: 8px;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;

  &:hover {
    background: var(--bg-tertiary);
    color: var(--text-primary);
    border-color: var(--accent-cyan);
    transform: translateY(-2px);
  }
`;

const Divider = styled.div`
  height: 1px;
  background: var(--border-subtle);
  width: 100%;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.85rem;
  color: var(--text-dim);

  @media (max-width: 600px) {
    justify-content: center;
    text-align: center;
  }
`;

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <FooterWrapper>
      <FooterContainer>
        <TopRow>
          <BrandBlock>
            <h4>
              Nimish Kushwaha<span>.dev</span>
            </h4>
            <p>Full Stack Developer &amp; Researcher • Kathmandu, Nepal</p>
          </BrandBlock>

          <SocialLinks>
            <SocialIcon
              href="https://github.com/NimishKushwaha"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub Profile"
              title="GitHub"
            >
              <FaGithub />
            </SocialIcon>
            <SocialIcon
              href="https://www.linkedin.com/in/nimishkushwaha01"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
              title="LinkedIn"
            >
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon
              href="http://instagram.com/nimishkushwaha01"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram Profile"
              title="Instagram"
            >
              <FaInstagram />
            </SocialIcon>
          </SocialLinks>

          <BackToTopButton onClick={scrollToTop} aria-label="Back to top">
            Back to Top <FaArrowUp />
          </BackToTopButton>
        </TopRow>

        <Divider />

        <BottomRow>
          <p>© {new Date().getFullYear()} Nimish Kushwaha. All rights reserved.</p>
        </BottomRow>
      </FooterContainer>
    </FooterWrapper>
  );
}
